import './MustLoginPopUp.css'

export default function MustLoginPopUp () {


    return (
        <div className="must-login-wrapper">
            <div className='pop-up'>
                Must be logged in to run code
            </div>
       </div>
    )
}